import { render } from "./Chess.vue?vue&type=template&id=138e0150&scoped=true"
import script from "./Chess.vue?vue&type=script&lang=js"
export * from "./Chess.vue?vue&type=script&lang=js"

import "./Chess.vue?vue&type=style&index=0&id=138e0150&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kvr\\Documents\\git\\krovyaka_io_source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138e0150"]])

export default __exports__